import type { ReactNode } from "react";

import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

import { InterludeEventTypes, useEventPublish } from "../events";
import type { ImportNodeTarget, NodeSelectionCriteria } from "../library/index.ts";
import { AddThumbnailItemButton } from "./AddThumbnailItemButton";

type Props = {
  disabled?: boolean;
  interludeOrchestratorId: number;
  browseTarget: ImportNodeTarget;
  templateCriteria: NodeSelectionCriteria;
  tooltip?: ReactNode;
};

export const AddOverlayButton = ({
  disabled,
  interludeOrchestratorId,
  browseTarget,
  templateCriteria,
  tooltip,
}: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  const publish = useEventPublish();

  const handleCreateYourOwn = () => publish(InterludeEventTypes.ADD_INTERLUDE_REQUESTED, { interludeOrchestratorId });

  return (
    <AddThumbnailItemButton
      disabled={disabled}
      tooltip={tooltip ?? formatMessage("addOverlay")}
      browseLabel={formatMessage("browseOverlayTemplates")}
      pasteLabel={formatMessage("pasteOverlay")}
      browseTarget={browseTarget}
      templateCriteria={templateCriteria}
      onCreateYourOwn={handleCreateYourOwn}
      data-test="add-overlay-button"
    />
  );
};

const formatStrings = {
  addOverlay: {
    en: "Add Overlay",
  },
  browseOverlayTemplates: {
    en: "Browse Overlay Templates",
  },
  pasteOverlay: {
    en: "Paste Overlay",
  },
} satisfies FormatMessages;
